import { Typography } from '@mui/material';

import type { InspectorDTO } from 'src/types/dto';

type Props = {
  inspector: InspectorDTO;
};

export function BusinessUnitCell({ inspector }: Props) {
  const label =
    inspector.businessUnit?.name ?? inspector.user?.businessUnits?.[0]?.name ?? '—';

  return (
    <Typography variant="body2" noWrap>
      {label}
    </Typography>
  );
}
